import { InterceptType } from '../../../__generated__/fed-graphql-types'
import React from 'react'
import { getRelevanceInterceptContent } from './relevance-intercept-content'
import { getValuationInterceptContent } from './valuation-intercept-content'
import { useForm } from '../../../forms/hocs/form.context'

export type InterceptContent = {
    pictogram: React.ReactElement
    trackingLabel: string
    componentNameLabel: string
    handleClick: () => void
}

export const useInterceptContent = (
    interceptType: InterceptType,
    position: number,
    updatedSort: string | null
): InterceptContent => {
    const { selectedMap, updateSortBySelected, sortBySelected } = useForm()

    switch (interceptType) {
        case InterceptType.VALUATION:
            return getValuationInterceptContent(position, selectedMap)
        case InterceptType.RELEVANCE_SEARCH:
            return getRelevanceInterceptContent(position, updatedSort, updateSortBySelected, sortBySelected)
    }
}
